import { CardProps } from '../contexts/OneClickBuyContext/types/Cards';
import { TransactionProps } from '../contexts/OneClickBuyContext/types/Payment';
import { TransactionStatus } from '../contexts/OneClickBuyContext/types/Transaction';
import { isConfirmedPayment } from './oneClickBuyOutcome';

export const getReferenceTransaction = (transactions: TransactionProps[] = []): TransactionProps | undefined =>
	transactions.find(({ status }) => isConfirmedPayment(status)) ??
	transactions.find(({ status }) => status !== TransactionStatus.EXPIRED) ??
	transactions[0];

export const getTransactionCards = (transactions: TransactionProps[] = []): CardProps[] =>
	transactions.reduce<CardProps[]>((cards, { card }) => {
		if (card && !cards.some(({ code }) => code === card.code)) cards.push(card);
		return cards;
	}, []);
